import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function isInboxRuleEnabledByAdmin(): boolean {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (7,14): Object is possibly 'undefined'.
    // @ts-expect-error
    return !!getUserConfiguration().SegmentationSettings.Rules;
}
